import { defineStore } from 'pinia';
import { getSearch, getFilter } from '@/api/AppSearch';
export const useAppSearchStore = defineStore('appSearchStore', {
    state: () => {
        return {
            searchDataArray: [],
            searchFilterDataArray: [],
            globalContactsCount: 0,
            globalPropertyCount: 0,
            globalDiaryCount: 0,
            globalAllCount: 0,
            appSearchString: '',
            currentTab: 'all',
            pagination: 1,
            totalPages: 0,
            searchTabsArray: [
                {
                    id: '1',
                    title: 'All',
                    value: 'all',
                    count: 0,
                    isActive: true,
                },
                {
                    id: '2',
                    title: 'Diary',
                    value: 'diary',
                    count: 0,
                    isActive: false,
                },
                {
                    id: '3',
                    title: 'Inbox',
                    value: 'inbox',
                    count: 0,
                    isActive: false,
                },
                {
                    id: '4',
                    title: 'Timeline',
                    value: 'timeline',
                    count: 0,
                    isActive: false,
                },
                {
                    id: '5',
                    title: 'Contact',
                    value: 'contact',
                    count: 0,
                    isActive: false,
                },
                {
                    id: '6',
                    title: 'Properties',
                    value: 'property',
                    count: 0,
                    isActive: false,
                },
            ],
            filterObj: {
                all: {
                    additionalUrl: null,
                    checkedItems: [],
                },
                diary: {
                    event_id: [],
                    status: '',
                    user_id: [],
                    label_id: [],
                    additionalUrl: null,
                    checkedItems: [],
                },
                inbox: {},
                timeline: {},
                contact: {
                    board_id: [],
                    user_id: [],
                    contact_type_id: [],
                    label_id: [],
                    additionalUrl: null,
                    checkedItems: [],
                },
                property: {
                    board_id: [],
                    user_id: [],
                    label_id: [],
                    additionalUrl: null,
                    checkedItems: [],
                },
                active: '',
            },
        };
    },
    getters: {},
    actions: {
        updateCounts() {
            console.log(this.searchDataArray[0], 'debug line'); // debugging line
            if (
                Object.prototype.hasOwnProperty.call(
                    this.searchDataArray[0],
                    'contact'
                )
            ) {
                this.globalContactsCount = this.searchDataArray[0].count;
                this.searchTabsArray[4].count = this.searchDataArray[0].count;
            } else if (
                Object.prototype.hasOwnProperty.call(
                    this.searchDataArray[0],
                    'property'
                )
            ) {
                this.globalPropertyCount = this.searchDataArray[0].count;
                this.searchTabsArray[5].count = this.searchDataArray[0].count;
            } else if (
                Object.prototype.hasOwnProperty.call(
                    this.searchDataArray[0],
                    'diary'
                )
            ) {
                this.globalDiaryCount = this.searchDataArray[0].count;
                this.searchTabsArray[1].count = this.searchDataArray[0].count;
            } else if (
                Object.prototype.hasOwnProperty.call(
                    this.searchDataArray[0],
                    'all'
                )
            ) {
                this.globalAllCount = this.searchDataArray[0].count;
                this.searchTabsArray[0].count = this.searchDataArray[0].count;
            }
        },
        async getResult(isNewSearch = false) {
            if (isNewSearch) {
                this.pagination = 1;
            }
            if (this.appSearchString.length > 1) {
                setTimeout(async () => {
                    try {
                        const response = await getSearch(
                            this.appSearchString,
                            this.currentTab,
                            this.pagination,
                            this.filterObj[this.currentTab].additionalUrl
                        );
                        if (response && response.code == 200) {
                            if (isNewSearch) {
                                this.searchDataArray = [];
                            }
                            this.searchDataArray.push(response.data);
                            this.totalPages = response.data.totalPages;
                            this.updateCounts();
                        }
                    } catch (e) {
                        return e.response;
                    }
                }, 300);
            }
        },
        async getFilterResult() {
            try {
                const response = await getFilter(
                    this.currentTab,
                    this.filterObj[this.currentTab].additionalUrl
                );
                if (response && response.code == 200) {
                    this.searchFilterDataArray = response.data;
                    console.log(
                        this.searchFilterDataArray,
                        'this.searchFilterDataArray'
                    );
                }
            } catch (e) {
                return e.response;
            }
        },
    },
    persist: {
        enabled: true,
        // strategies: [], // <- HERE
    },
});